import utils from './utils'
import Cookies from 'js-cookie'
import { provinceLevelCity, provinceCekidCity } from './enum'
import { getLocation as getLocationBySdk, geoCoderByLatLng } from 'bs-sdk'
export async function getLocation() {
  const isInLocalKidsMiniprogram = await utils.isInLocalKidsMiniprogram()
  if (isInLocalKidsMiniprogram) {
    const gps = {
      lat: Cookies.get('lat') || '',
      lng: Cookies.get('lng') || ''
    }
    try {
      const result = await geoCoderByLatLng(gps.lat, gps.lng)
      return result || gps
    } catch (error) {
      console.log(error)
    }
    return gps
  }
  const location = (await getLocationBySdk()) || {}
  return location
}

export function getCityCode(citycode) {
  if (!citycode) {
    return '320100'
  } else {
    let city = citycode
    if (provinceLevelCity.includes(citycode * 1)) {
      city = citycode - 0 + 100
    }
    return city
  }
}
export function getCekidCityCode(citycode) {
  if (!citycode) {
    return '320100'
  } else {
    let city = citycode
    if (provinceCekidCity.includes(citycode * 1)) {
      city = citycode - 0 - 100
    }
    return city
  }
}

export async function getLatAndLng() {
  const isInLocalKidsMiniprogram = await utils.isInLocalKidsMiniprogram()
  if (isInLocalKidsMiniprogram) {
    return {
      lat: Cookies.get('lat'),
      lng: Cookies.get('lng')
    }
  }
  if (utils.getDevice() === 'ios' || utils.getDevice() === 'android') {
    return getAPPLatAndLng()
  } else {
    const position = await getLocationBySdk()
    return position
  }
}
export function getAPPLatAndLng() {
  try {
    let gps = ''
    if (utils.getDevice() === 'ios') {
      gps = window.localjs.getgps()
    } else if (utils.getDevice() === 'android') {
      gps = window.localjs.getkwgps()
    }
    if (gps && typeof gps === 'string' && gps.indexOf('_') > -1) {
      const [lat, lng] = gps.split('_')
      return { lat, lng }
    } else {
      return { lat: '', lng: '' }
    }
  } catch (e) {
    console.log('===获取app经纬度失败=====')
    return { lat: '', lng: '' }
  }
}

export default {
  getLocation,
  getCityCode,
  getCekidCityCode,
  getAPPLatAndLng
}
